import React from "react";
import { TextLink } from "@ovotech/element";
export const JumptechLink = () => {
  return (
    <TextLink opensInNewWindow href={"https://www.jumptech.eco/about/"}>
      Jumptech
    </TextLink>
  );
};
